import styled from "styled-components";

export const Subheader = styled.h3`
  text-align: center;
  font-size: 15px;
  margin-top: 0px;
`;
